import React from "react";
import logo from "../../img/logo.png";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const handleLogout = () => {
    console.log("tıkladın");
    localStorage.removeItem("token");
    window.location.href = "/";
    // localStorage.removeItem("token");
  };

  return (
    <>
      <nav className="sticky bg-[#131418] px-2 sm:px-4 py-2.5  w-full z-20 top-0 left-0">
        <div className="container flex flex-wrap justify-between items-center mx-auto">
          <a href="/" className="flex items-center">
            <img
              src={logo}
              className="mr-3 h-6 sm:h-9"
              alt="Flowbite Logo"
            ></img>
            <span className="self-center text-xl font-semibold whitespace-nowrap text-white">
              PayCoLife
            </span>
          </a>

          <div className="flex md:order-2">
            {/* <button type="button">Get started</button> */}

            {localStorage.getItem("token")?.length > 20 ? (
              <div className="space-x-4 flex flex-row">
                <Link
                  to={"/Panel"}
                  className="hidden md:flex items-center justify-evenly focus:outline-none outline-none"
                >
                  <div className="text-white bg-[#3742fa] cursor-pointer hover:bg-[#5352ed] focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 ">
                    <p>Panel</p>
                  </div>
                </Link>
                <div
                  onClick={handleLogout}
                  className="hidden md:flex text-white cursor-pointer bg-[#ff3333] hover:bg-[#5352ed] focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 "
                >
                  <span className="flex items-center justify-evenly focus:outline-none outline-none">
                    <p>Logout</p>
                  </span>
                </div>
              </div>
            ) : (
              <div className="text-white bg-[#3742fa] hover:bg-[#5352ed] focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 ">
                <Link
                  to="/Register"
                  className="flex items-center justify-evenly focus:outline-none outline-none"
                >
                  <p>Get started</p>
                </Link>
              </div>
            )}

            <button
              type="button"
              onClick={() => setToggleMenu(!toggleMenu)}
              className="inline-flex items-center p-2 text-sm rounded-lg md:hidden  focus:outline-none "
            >
              <span className="sr-only">Open main menu</span>
              {toggleMenu ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#ffffff"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#ffffff"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </button>
          </div>
          <div
            className="hidden justify-between items-center w-full md:flex md:w-auto md:order-1"
            id="navbar-sticky"
          >
            <ul className="flex flex-col p-4 mt-4 rounded-lg border  md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 ">
              <li>
                <a
                  href="/"
                  className="block py-2 pr-4 pl-3 text-white rounded md:bg-transparent  md:p-0 "
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="block py-2 pr-4 pl-3 text-white rounded  md:hover:bg-transparent md:hover:text-[#3742fa] md:p-0  "
                >
                  About
                </a>
              </li>

              <li>
                <a
                  href="/contact"
                  className="block py-2 pr-4 pl-3 text-white rounded  md:hover:bg-transparent md:hover:text-[#3742fa] md:p-0  "
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* mobil menu */}
        {toggleMenu && (
          <div className="md:hidden w-full block md:w-auto">
            <ul className="flex flex-col p-5 mx-2 space-y-1">
              <li>
                <a
                  href="/"
                  className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer "
                >
                  Home
                </a>
              </li>

              <li>
                <a
                  href="/about"
                  className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                >
                  Contact
                </a>
              </li>
            </ul>

            {localStorage.getItem("token")?.length > 20 && (
              <>
                <h2 className="text-white px-6 mt-2 text-xl">Panel</h2>
                <ul className="flex flex-col p-5 mx-2 space-y-1">
                  <li>
                    <a
                      href="/panel"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      My Information
                    </a>
                  </li>

                  <li>
                    <a
                      href="/servers"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      Servers
                    </a>
                  </li>

                  <li>
                    <a
                      href="/myservers"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      My Servers
                    </a>
                  </li>

                  <li>
                    <a
                      href="/withdraw"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      Withdraw
                    </a>
                  </li>

                  <li>
                    <a
                      href="/deposit"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      Deposit
                    </a>
                  </li>
                  <li>
                    <a
                      href="/paycolife"
                      className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer"
                    >
                      How is it work
                    </a>
                  </li>
                  <li onClick={handleLogout}>
                    <span className="block p-2 hover:bg-white hover:text-blue-700 text-white border-b border-blue-500 rounded cursor-pointer">
                      Logout
                    </span>
                  </li>
                </ul>
              </>
            )}
          </div>
        )}
      </nav>
    </>
  );
}
